import { memo, useEffect, useState } from "react";

// Helpers
import { useTranslate } from "helpers";

// Types
import { VehicleContractSaleContentProps } from "./types";
import { Dropdown } from "ui/components/Dropdown/Dropdown";
import { DropdownOption } from "ui/components/Dropdown/Dropdown/types";
import { useHandleDropdownChange } from "services/forms/hooks";
import { DataWithPagination } from "services/api";

import { initialDataWithPagination } from "services/api/consts";
import { Pagination } from "services/search";

import { getContractSaleTemplatesAPI } from "services/api/settings/documents/api";
import { ContractSaleTemplateRow } from "services/api/settings/documents/types";



const VehicleContractSaleContent: React.FC<VehicleContractSaleContentProps> = ({
  formValues,
  setFormValues,
  errors,
  setErrors
}) => {
  const { t } = useTranslate();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [searchResults, setSearchResults] = useState<DataWithPagination<ContractSaleTemplateRow>>(initialDataWithPagination);

  useEffect(() => {
    let isMounted = true;

    const loadData = async () => {
      if (isMounted) {
        await fetchSearchResult(searchResults.pagination);
      }
    };

    loadData();

    return () => {
      isMounted = false;
    };
  }, []);

  const fetchSearchResult = async (
    pagination: Pagination,
  ) => {
    setIsLoading(true);
    try {
      const results = await getContractSaleTemplatesAPI(pagination);
      setSearchResults(results);
    } catch (error: any) {
      // Handle 404 - endpoint not found
      if (error?.response?.status === 404) {
        console.warn("Contract templates endpoint not available (404). This feature may not be implemented yet.");
      }
      setSearchResults(initialDataWithPagination);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (
      searchResults.data.length > 0 &&
      !formValues.contractSaleTemplateId
    ) {
      setFormValues((prev) => ({
        ...prev,
        contractSaleTemplateId: searchResults.data[0].id,
      }));
    }
  }, [searchResults.data]);



  const contractSaleTemplates: DropdownOption[] = searchResults?.data?.map((i) => {
    return {
      value: i.id,
      text: i.name,
    };
  });

  const handleDropdownChange = useHandleDropdownChange(
    setFormValues,
    formValues
  );


  return (
    <>

      {/* <div className="mb-3 text-sm uppercase text-slate-500 font-medium">
          {t("admin.fleet.vehicle.contract.add.tab.content.template.title")}
        </div> */}
      {/* <p className="text-sm text-slate-600 mb-3">
           {t("admin.fleet.vehicle.contract.add.tab.content.template.description")}
        </p> */}
      <div className="flex gap-3 mb-3">
        <div className="flex-1">
          <Dropdown
            name="contractSaleTemplateId"
            label={t("admin.fleet.vehicle.contract.add.tab.content.templateid")}
            placeholder={t("admin.fleet.vehicle.contract.add.tab.content.templateid.placeholder")}
            options={contractSaleTemplates}
            value={formValues.contractSaleTemplateId}
            onChange={handleDropdownChange}
            required
            error={errors.contractSaleTemplateId}
          />
        </div>

      </div>
    </>
  );
};

export default memo(VehicleContractSaleContent);
